


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import FilterIcon from 'vue-material-design-icons/FilterVariant.vue'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import VSuggestionForm from '@/components/VSuggestionForm.vue'
import { Action, Getter, Mutation } from 'vuex-class'
import * as types from '@/store/content/types'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import CrossIcon from 'vue-material-design-icons/Close.vue'
import VueTagsInput from '@johmun/vue-tags-input'

@Component({ components: { CrossIcon, ChevronDown, ChevronUp, FilterIcon, VButton, VInput, VSuggestionForm, VueTagsInput } })
export default class FilterMenu extends Vue {
  @Action('contentFormats', { namespace: 'content' }) contentFormats!: types.ContentFormatsAction
  @Action('contentTypes', { namespace: 'content' }) contentTypes!: types.ContentTypesAction

  @Getter('filters', { namespace: 'content' }) getFilters!: { [key: string]: { [key: string]: boolean } }
  @Getter('isLoggedIn', { namespace: 'account' }) isLoggedIn!: boolean
  @Mutation('SET_FILTER', { namespace: 'content' }) setFilter!: types.SetFilter
  @Mutation('TOGGLE_FILTER', { namespace: 'content' }) toggleFilter!: types.ToggleFilter
  @Mutation('EMPTY_FILTERS', { namespace: 'content' }) emptyFilters!: types.EmptyFilters

  @Prop({ default: true }) showSearch!: boolean;
  @Prop({ default: false }) showSuggest!: boolean;

  private types: string[] = []
  private formats: string[] = []
  private showExpand: string | null = null
  private onlyFavorites = false
  private selectedFormats: { [key: string]: boolean } = {}
  private selectedTypes: { [key: string]: boolean } = {}
  private tag = ''
  private tags = []
  private ua = (this as any).$ua

  private created () {
    this.emptyFilters()
    this.setFilter({ name: 'content_format', value: {} })
    this.setFilter({ name: 'content_type', value: {} })
    this.setFilter({ name: 'favorites', value: {} })
    this.contentTypes().then((response) => {
      this.types = response.map(elem => elem.name)
    })
    this.contentFormats().then((response) => {
      this.formats = response.map(elem => elem.name)
    })
    this.selectedFormats = this.getFilters.content_format
    this.selectedTypes = this.getFilters.content_type
  }

  private handleFavoriteClick () {
    this.toggleFilter({ name: 'favorites', value: 'only' })
    this.onlyFavorites = this.getFilters.favorites.only
  }

  private handleFormatClick (format: string) {
    this.toggleFilter({ name: 'content_format', value: format })
    this.selectedFormats = {} // reset selectedFormats so Vue reactivity picks it up
    this.selectedFormats = this.getFilters.content_format
    if (this.selectedFormats[format]) {
      this.ua.trackEvent('filter', 'format', format)
    }
  }

  private handleTypeClick (type: string) {
    this.toggleFilter({ name: 'content_type', value: type })
    this.selectedTypes = {} // reset selectedFormats so Vue reactivity picks it up
    this.selectedTypes = this.getFilters.content_type
    if (this.selectedTypes[type]) {
      this.ua.trackEvent('filter', 'type', type)
    }
  }

  private handleTagsChange (newTags: any) {
    this.tags = newTags
    this.$store.commit('content/SET_SEARCH_TAGS', newTags.map((tag: any) => tag.text))
    this.ua.trackEvent('filter', 'tags', newTags.map((tag: any) => tag.text).reduce((acc: string, curr: string) => { acc += curr }, ''))
  }

  private get nFilters () {
    return Object.values(this.selectedFormats).filter(f => f === true).length +
      Object.values(this.selectedTypes).filter(f => f === true).length +
      this.tags.length
  }
}
